export const TOGGLE_SORT_DIRECTION = 'stats/reports/schedule/TOGGLE_SORT_DIRECTION';
export const toggleSortDirection = () => ({ type: TOGGLE_SORT_DIRECTION });

export const initialState = {
  sortDirection: 'dsc',
};

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case TOGGLE_SORT_DIRECTION:
      return { ...state, sortDirection: state.sortDirection === 'dsc' ? 'asc' : 'dsc' };
    default:
      return state;
  }
};
